webpackJsonp([103303225716578],{

/***/ 1181:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/suggestions/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-suggestions-60a4b5be748cdb486b87.js